import { START_SYNC_PULL, SYNC_ERROR, HANDLE_NEW_QDD, START_SYNC_CHECK, START_SYNC_PUSH, SYNC_PUSH_FINISHED, START_RESPONSE_PUSH, FINISHED_RESPONSE_PUSH, RESPONSE_FETCH_ERROR, FINISHED_RESPONSE_FETCH } from '../actions/sync';
import { TOGGLE_QUESTION_FLAGGED, SAVE_ANSWER, SAVE_ANSWER_NOTE, POSTING_ANSWER, POSTED_ANSWER, SYNCING_USER_EDITS } from '../actions/response';
import { SORT_OPTIONS, SAVE_NOTE, DELETE_NOTE, TOGGLE_OPTION_HIDDEN, BULK_TOGGLE_OPTIONS_HIDDEN, TOGGLE_STAR, UPDATE_REVIEW_STAGE } from '../actions/userEdits';
import {CREATE_NEW_RESPONSE} from '../actions/responseMetadata';
import {ADD_TAG, UPDATE_TAG, DELETE_TAG} from '../actions/tags';
import {setNextID} from './generateID';
import { UPDATE_SORT_INDEXES } from '../actions/question';
import {  REMOVE_FROM_ANSWERS_TO_SYNC } from "../hooks/useBackgroundSync";
import { CREATE_TRANSLATION, SAVE_TR_METADATA, SAVE_TR_FOR_RESPONSE } from '../actions/translation'

const sync = (state = {lastSynced: 0, isSyncing: false, syncError: false, version: 0, hasLoadedQDD: false, localChanges: false, localquestionnaireChanges: false, answersToSync: []}, action) => {
  switch(action.type) {
    case POSTING_ANSWER:
      return {
        ...state,
        isPostingAnswer: true
      }
    case POSTED_ANSWER:
      return {
        ...state,
        isPostingAnswer: false
      }
    case SAVE_ANSWER:
    case SAVE_ANSWER_NOTE:
    case TOGGLE_QUESTION_FLAGGED: {
      let answersToSync = state.answersToSync || [];
      let id = action.question || action.id;
      if (answersToSync.indexOf(id) === -1) {
        answersToSync.push(id);
      }
      return {
        ...state,
        answersToSync,
      }
    }
    case REMOVE_FROM_ANSWERS_TO_SYNC:
        let answersToSync = (state.answersToSync || []).filter((id) => action.ids.indexOf(id) === -1);
        return {
          ...state,
          answersToSync
        }
    case SORT_OPTIONS:
    case SAVE_NOTE:
    case DELETE_NOTE:
    case TOGGLE_OPTION_HIDDEN:
    case BULK_TOGGLE_OPTIONS_HIDDEN:
    case TOGGLE_STAR:
    case UPDATE_REVIEW_STAGE:
    case SAVE_TR_FOR_RESPONSE:
      return {
        ...state,
        plzSyncUserEdits: true
      }
    case SYNCING_USER_EDITS:
      return {
        ...state,
        plzSyncUserEdits: false
      }
    case START_SYNC_PULL:
      return {
        ...state,
        isSyncing: true,
        syncError: null
      }
    case SYNC_ERROR:
      return {
        ...state,
        isSyncing: false,
        syncError: action.msg
      }
    case START_SYNC_CHECK:
      return {
        ...state,
        syncError: null
      }
    case HANDLE_NEW_QDD:
      setNextID(action.payload);
      return {
        ...state,
        lastSynced: new Date().getTime(),
        isSyncing: false,
        syncError: null,
        version: action.payload.version,
        hasLoadedQDD: true
      }
    case START_SYNC_PUSH:
    case START_RESPONSE_PUSH:
      return {
        ...state,
        isSyncing: true,
        syncError: null
      }
    case 'CREATE_CATEGORY':
    case 'UPDATE_CATEGORY':
    case 'DELETE_CATEGORY':
    case 'CREATE_OPTION':
    case 'UPDATE_OPTION':
    case 'DELETE_OPTION':
    case 'CREATE_QUESTION':
    case 'UPDATE_QUESTION':
    case 'DELETE_QUESTION':
    case UPDATE_SORT_INDEXES:
    case ADD_TAG:
    case UPDATE_TAG:
    case DELETE_TAG:
    case CREATE_TRANSLATION:
    case SAVE_TR_METADATA:
      return {
        ...state,
        version: state.version + 1,
        localChanges: true
      }
    // case SAVE_ANSWER:
    // case SAVE_ANSWER_NOTE:
    // case TOGGLE_QUESTION_FLAGGED:
    case CREATE_NEW_RESPONSE:
    // case SORT_OPTIONS:
    // case SAVE_NOTE:
    // case DELETE_NOTE:
      return {
        ...state,
        localquestionnaireChanges: true
      }
    case SYNC_PUSH_FINISHED:
      return {
        ...state,
        localChanges: false,
        isSyncing: false,
        version: action.version || state.version
      }
    case FINISHED_RESPONSE_PUSH:
      return {
        ...state,
        localquestionnaireChanges: false,
        isSyncing: false
      }
    case RESPONSE_FETCH_ERROR:
      return {
        ...state,
        responseFetchError: action.msg,
        isFetchingResponse: false,
        fetchedResponse: null
      }
    case FINISHED_RESPONSE_FETCH:
      return {
        ...state,
        fetchedResponse: action.payload
      }
    // case CONVERT_TO_SAVED_RESPONSE:
    //   return {
    //     ...state,
    //     localquestionnaireChanges: true
    //   }
    default:
      return state;
  }
}

export default sync;
